import React from 'react'
import { Table } from 'lib/ui'

const TABLE_STRUCTURE_TAG =
  /<\/?(?:table|caption|colgroup|col|thead|tbody|tfoot|tr|td|th)\b[^>]*>/gi

// Scraped cells sometimes contain stray table tags; the browser nests them and SSR hydration breaks (MAD-135c).
export function cellHtml(value) {
  if (typeof value !== 'string') return value
  return value.replace(TABLE_STRUCTURE_TAG, '')
}

const Products = ({ data }) => {
  const columns = [
    ...new Set(data.reduce((acc, x) => acc.concat(Object.keys(x)), [])),
  ]

  return (
    <Table celled stackable collapsing>
      <Table.Header>
        <Table.Row>
          {columns.map(col => (
            <Table.HeaderCell key={col}>{col}</Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {data.map((d, i) => (
          <Table.Row key={i}>
            {columns.map(col => (
              <Table.Cell key={col} verticalAlign="top">
                <span dangerouslySetInnerHTML={{ __html: cellHtml(d[col]) }} />
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  )
}

export default Products
